(function() {
    var TeamMemberMiniCarousel = {
        miniCarouselElement : null,
        miniCarouselContentElement : null,

        miniCarouselSlides : [],
        miniCarouselContentSlides : [],

        numberOfSlides : 0,

        carouselControlsWrapperElement : null,
        carouselControlsPrevElement : null,
        carouselControlsNextElement : null,

        isTransitioning : false,

        activeIndex : 0,

        resetSlides : function(previousIndex) {
            if ( this.activeIndex == 0 ) {
                this.miniCarouselSlides[previousIndex].style.zIndex = this.numberOfSlides;
                for ( var i = 0; i < this.numberOfSlides; i++ ) {
                    if ( !this.miniCarouselSlides[i].classList.contains('active') ) {
                        this.miniCarouselSlides[i].classList.add('no-transition');
                        this.miniCarouselSlides[i].classList.remove('left');
                        this.miniCarouselSlides[i].classList.add('right');
                    }
                }
                requestAnimationFrame( function() {
                    this.miniCarouselSlides[previousIndex].classList.add('left');
                    this.miniCarouselSlides[previousIndex].classList.remove('active');
                    this.miniCarouselSlides[this.activeIndex].classList.remove('no-transition');
                    this.miniCarouselSlides[this.activeIndex].classList.add('active');
                    this.miniCarouselSlides[this.activeIndex].classList.remove('right');
                    setTimeout( function() {
                        for ( var i = 0; i < this.numberOfSlides; i++ ) {
                            if ( i != previousIndex ) {
                                this.miniCarouselSlides[i].classList.remove('no-transition');
                            }
                        }
                        this.miniCarouselSlides[previousIndex].classList.add('no-transition');
                        this.miniCarouselSlides[previousIndex].classList.remove('left');
                        this.miniCarouselSlides[previousIndex].classList.add('right');
                        this.miniCarouselSlides[previousIndex].style.zIndex = (this.numberOfSlides - 1) - previousIndex;
                        requestAnimationFrame( function() {
                            this.miniCarouselSlides[previousIndex].classList.remove('no-transition');
                        }.bind(this));
                    }.bind(this), 1000);

                }.bind(this));
            } else if ( this.activeIndex == this.numberOfSlides - 1 ) {
                this.miniCarouselSlides[this.activeIndex].style.zIndex = this.numberOfSlides;
                for ( var i = 0; i < this.numberOfSlides; i++ ) {
                    if ( !this.miniCarouselSlides[i].classList.contains('active') ) {
                        this.miniCarouselSlides[i].classList.add('no-transition');
                        this.miniCarouselSlides[i].classList.add('left');
                        this.miniCarouselSlides[i].classList.remove('right');
                    }
                }
                requestAnimationFrame( function() {
                    this.miniCarouselSlides[previousIndex].classList.add('right');
                    this.miniCarouselSlides[previousIndex].classList.remove('active');
                    this.miniCarouselSlides[this.activeIndex].classList.remove('no-transition');
                    this.miniCarouselSlides[this.activeIndex].classList.add('active');
                    this.miniCarouselSlides[this.activeIndex].classList.remove('left');
                    setTimeout( function() {
                        for ( var i = 0; i < this.numberOfSlides; i++ ) {
                            if ( i != previousIndex ) {
                                this.miniCarouselSlides[i].classList.remove('no-transition');
                            }
                        }
                        this.miniCarouselSlides[previousIndex].classList.add('no-transition');
                        this.miniCarouselSlides[previousIndex].classList.remove('right');
                        this.miniCarouselSlides[previousIndex].classList.add('left');
                        this.miniCarouselSlides[this.activeIndex].style.zIndex = (this.numberOfSlides - 1) - this.activeIndex;
                        requestAnimationFrame( function() {
                            this.miniCarouselSlides[previousIndex].classList.remove('no-transition');
                        }.bind(this));
                    }.bind(this), 1000);

                }.bind(this));
            }
        },

        handleContentChange : function(previousIndex) {
            this.isTransitioning = true;

            this.miniCarouselContentSlides[previousIndex].classList.add('leaving');
            var timeout = this.miniCarouselContentSlides[previousIndex].style.transitionDuration;
            setTimeout( function() {
                this.miniCarouselContentSlides[previousIndex].classList.remove('active');
                this.miniCarouselContentSlides[previousIndex].classList.remove('leaving');
                this.miniCarouselContentElement.style.height = this.miniCarouselContentSlides[this.activeIndex].offsetHeight + "px";
                setTimeout( function() {
                    this.miniCarouselContentSlides[this.activeIndex].classList.add('active');
                    this.isTransitioning = false;
                }.bind(this), 500);
            }.bind(this), 250);

        },

        handleNext : function() {
            if ( this.activeIndex + 1 >= this.numberOfSlides ) {
                var previousIndex = this.activeIndex;
                this.activeIndex = 0;
                this.resetSlides(previousIndex);
                this.handleContentChange(previousIndex);
            } else {
                var previousIndex = this.activeIndex;
                this.miniCarouselSlides[this.activeIndex].classList.add('left');
                this.miniCarouselSlides[this.activeIndex].classList.remove('active');
                this.activeIndex++;
                this.miniCarouselSlides[this.activeIndex].classList.add('active');
                this.miniCarouselSlides[this.activeIndex].classList.remove('right');

                this.handleContentChange(previousIndex);
            }
        },

        handlePrev : function() {
            if ( this.activeIndex - 1 < 0 ) {
                var previousIndex = this.activeIndex;
                this.activeIndex = this.numberOfSlides - 1;
                this.resetSlides(previousIndex);
                this.handleContentChange(previousIndex);
            } else {
                var previousIndex = this.activeIndex;
                this.miniCarouselSlides[this.activeIndex].classList.add('right');
                this.miniCarouselSlides[this.activeIndex].classList.remove('active');
                this.activeIndex--;
                this.miniCarouselSlides[this.activeIndex].classList.add('active');
                this.miniCarouselSlides[this.activeIndex].classList.remove('left');
                
                this.handleContentChange(previousIndex);
            }
        },

        addEventListeners : function() {
            this.carouselControlsNextElement.addEventListener('click', function(e) {
                if ( ! this.isTransitioning ) {
                    this.handleNext();
                }
            }.bind(this));
            this.carouselControlsPrevElement.addEventListener('click', function(e) {
                if ( ! this.isTransitioning ) {
                    this.handlePrev();
                }
            }.bind(this));
        },

        init : function(miniCarouselElement, miniCarouselContentElement) {
            this.miniCarouselElement = miniCarouselElement;
            this.miniCarouselContentElement = miniCarouselContentElement;
            this.miniCarouselSlides = this.miniCarouselElement.querySelectorAll('[data-mini-carousel-slide]');
            this.miniCarouselContentSlides = this.miniCarouselContentElement.querySelectorAll('[data-mini-carousel-content-slide]');
            this.miniCarouselContentElement.style.height = this.miniCarouselContentSlides[this.activeIndex].offsetHeight + "px";            
            this.numberOfSlides = this.miniCarouselSlides.length;

            this.carouselControlsWrapperElement = this.miniCarouselElement.querySelector('[data-mini-carousel-controls]');
            this.carouselControlsPrevElement = this.miniCarouselElement.querySelector('[data-mini-carousel-prev]');
            this.carouselControlsNextElement = this.miniCarouselElement.querySelector('[data-mini-carousel-next]');

            this.addEventListeners();
        }
    }

    var TeamMemberMiniCarouselConfig = {
        MiniCarousels : [],
        init : function() {
            var miniCarouselElements = document.querySelectorAll('[data-team-member-mini-carousel]');
            for ( var i = 0; i < miniCarouselElements.length; i++ ) {
                var miniCarousel = Object.assign({}, TeamMemberMiniCarousel);
                var miniCarouselElement = miniCarouselElements[i];
                var miniCarouselId = miniCarouselElement.getAttribute('data-team-member-mini-carousel') 
                var miniCarouselContentElement = document.querySelector('[data-team-member-mini-carousel-content="' + miniCarouselId + '"]');
                miniCarousel.init(miniCarouselElements[i], miniCarouselContentElement);
                this.MiniCarousels.push(miniCarousel);
            }
        }
    }

    window.wghi.TeamMemberMiniCarouselConfig = TeamMemberMiniCarouselConfig;

    document.addEventListener('DOMContentLoaded', function() {
        window.wghi.TeamMemberMiniCarouselConfig.init();
    });
})();